import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 10%;
  border: ${({ selected }) => (selected ? '2px red solid !important' : '')};
  margin: 0 0.25rem 0.25rem;
  padding: 0.5rem 0.75rem;
  color: white;
  transition: ${({ selected }) => (selected ? 'opacity 300ms ease' : '')};
  opacity: ${({ selected }) => (selected ? '0.8' : '1')};
`;

const Text = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
`;

const buttonColor = (
  shortlisted,
  discarded,
  selected,
  deal,
  updated,
  drafted,
  archived
) => {
  if (selected) {
    return 'button--standard';
  }
  if (!shortlisted && !discarded && !discarded && updated) {
    return 'button--red';
  }
  if (shortlisted && !deal && !discarded && updated) {
    return 'button--yelow';
  }
  if (discarded && !deal) {
    return 'button--grey';
  }
  if (deal && !discarded && updated) {
    return 'button--green';
  }
  if (drafted) {
    return 'button--draft';
  }
  if (archived) {
    return 'button--grey';
  }
  return 'button--standard';
};

const Slip = ({
  name,
  onSlipSelect,
  selected,
  shortlisted,
  discarded,
  deal,
  updated,
  drafted,
  archived,
}) => {
  const [updated1, setUpdated] = useState(updated);
  return (
    <Container
      selected={selected}
      onClick={() => onSlipSelect(setUpdated(false))}
      className={buttonColor(
        shortlisted,
        discarded,
        selected,
        deal,
        updated1,
        drafted,
        archived
      )}
    >
      <Text>{name}</Text>
    </Container>
  );
};

export default Slip;
